import {Component, OnInit} from '@angular/core';
import { AlertController, ToastController } from '@ionic/angular';
import {Api} from '../../../providers/api/api';
import {Events} from '../../../providers/events';
import {ViewController} from '../../../providers/view-controller.service';

@Component({
  selector: 'page-team',
  templateUrl: 'team.html',
  styleUrls: ['./team.scss']
})
export class TeamPage implements OnInit {

  contactData: Array<any> = [];

  constructor(public viewCtrl: ViewController, private api: Api, private events: Events, private alertController:AlertController, private toastController:ToastController) {

    this.events.subscribe('delPhoneData', (data) => {
      data.addressData.contacts = data.phoneData;
    });

  }

  ngOnInit() {
    this.api.get('contactGroups').subscribe({next:(res: any) => {
      this.contactData = res.data.data.data.docs;
    }, error:(err) => {
      debugger;
    }});
  }

  setPhoneContact(data) {
  }

  updateContactNumbers(data) {
  }

  takeOver(data?) {
    if (data) {
      this.viewCtrl.dismiss(data.contacts);
    } else {
      this.viewCtrl.dismiss();
    }
  }

  dismiss() {
    this.viewCtrl.dismiss();
  }

  async createGroup() {
    const alert = await this.alertController.create({
      header: "Neue Gruppe anlegen",
      inputs: [
        {
          name: 'group',
          type: 'text',
          placeholder: 'Gruppen-Name'
        }
      ],
      buttons: [
        {
          text: 'Abbrechen',
          role: 'cancel',
          cssClass: 'secondary',
          handler: () => {
            console.log('Confirm Cancel');
          }
        }, {
          text: 'Anlegen',
          handler: (data) => {
            const newGroup = {
              contacts:[],
              group: data.group
            }

            this.contactData.unshift(newGroup);    
          }
        }
      ]

    });

    alert.present();
  }

  trash(ct) {
    const idx = this.contactData.findIndex(contact => contact._id === ct._id);

    if(idx !== -1) {
      this.contactData.splice(idx, 1);
      this.api.delete('contactGroups', {_id:ct._id, _rev:ct._rev}).subscribe((xxx) => {
        debugger;
        this.showToast();
      })
    }
  }

  private async showToast() {
    const toast = await this.toastController.create({
      message: 'Kontaktgruppen wurden gespeichert',
      duration: 3000,
      position: 'top'
    });
    toast.present();
  }

  async saveData() {

    await this.api.asyncForEach(this.contactData, async (contact) => {
      await new Promise((resolve) => {
        if(!contact._id) {
          this.api.post('contactGroups', {body: contact}).subscribe((res:any) => {
            contact._id = res.data.data.data.id;
            contact._rev = res.data.data.data.rev;
            resolve(null);
          });
        } else {
          this.api.put('contactGroups', {body: contact}).subscribe((res:any) => {
            contact._rev = res.data.data.data.rev;
            resolve(null);
          }); 
        } 
      });  
    });

    this.showToast();
   
  }

}
